type Props = {
    isOpen: boolean;
    color: string;
};

const ArrowToggle: React.FC<Props> = ({ color, isOpen }) => {
    return (
        <img
            className={`transform transition-all duration-300 ${isOpen ? 'rotate-180' : ''} `}
            src={`data:image/svg+xml,%3csvg%20width='12'%20height='8'%20viewBox='0%200%2012%208'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.9057%202.08905L6.00573%207.00364C5.9474%207.06197%205.8842%207.10339%205.81615%207.12789C5.74809%207.15239%205.67517%207.16444%205.5974%207.16405C5.51962%207.16405%205.4467%207.152%205.37865%207.12789C5.31059%207.10378%205.2474%207.06236%205.18906%207.00364L0.274479%202.08905C0.138368%201.95294%200.0703125%201.7828%200.0703125%201.57864C0.0703125%201.37447%200.143229%201.19947%200.289063%201.05364C0.434896%200.907804%200.605035%200.834888%200.799479%200.834888C0.993924%200.834888%201.16406%200.907804%201.3099%201.05364L5.5974%205.34114L9.8849%201.05364C10.021%200.917526%2010.1888%200.849471%2010.3883%200.849471C10.5878%200.849471%2010.7603%200.922387%2010.9057%201.06822C11.0516%201.21405%2011.1245%201.38419%2011.1245%201.57864C11.1245%201.77308%2011.0516%201.94322%2010.9057%202.08905Z'%20fill='${color}'%20/%3e%3c/svg%3e`}
            alt=""
        ></img>
    );
};

export default ArrowToggle;
